import React from "react";

interface Props {
  children: React.ReactNode;
}

const CalendarRootComponent: React.FC<Props> = ({ children }) => {
  return <>{children}</>;
};

export default CalendarRootComponent;
